import React from 'react';
import { createRoot } from 'react-dom/client';
import { initializeBlipDS } from '@/core/utils/webComponent';
import { App } from '@/App';
import { ToastProvider } from '@/core/components/ToastProvider/ToastProvider';
import { registerMenuComponent } from '@/features/menu/register';
import { registerSchedulerComponent } from '@/features/scheduler/register';
import { registerHeaderComponent } from '@/features/header/register';
import { registerPublicationWallComponent } from '@/features/publication-wall/register';
import { registerClassificationComponent } from '@/features/classification/register';
import { registerAccountManagerComponent } from '@/features/account-manager/register';
import { registerCentralComponent } from '@/features/central/register';
import { registerNewSetupComponent } from '@/features/new-setup/register';
import { registerMetricsMenuComponent } from '@/features/metrics-menu/register';
import { initI18n } from '@/core/config/i18n';

// Initialize i18n
initI18n('pt');

// Register custom elements from their respective features
registerMenuComponent();
registerSchedulerComponent();
registerHeaderComponent();
registerPublicationWallComponent();
registerClassificationComponent();
registerAccountManagerComponent();
registerCentralComponent();
registerNewSetupComponent();
registerMetricsMenuComponent();

initializeBlipDS()
  .then(() => {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      const root = createRoot(rootElement);
      root.render(
        React.createElement(
          ToastProvider,
          null,
          React.createElement(App, null)
        )
      );
    }
  });


